import service from '../index';
import config from '@/assets/config.json';

/**
 * @亲子项目评价管理模块
 * 
 * @config.babyHttps.api 
 */

const token = localStorage.getItem('Beitoken')

// 获取评价列表
export function getEvaluationList(params) {
    const url = config.babyHttps.api + '/apitravel/admin/comment/list';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 获取评价详情
export function getEvaluationDetail(params) {
    const url = config.babyHttps.api + '/apitravel/admin/comment/info';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 回复/删除评价内容
export function setEvaluationContent(data) {
    const url = config.babyHttps.api + '/apitravel/admin/comment/rep';
    return service({
        method: 'post',
        url,
        data,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

